import { ConcreteNotifications } from '../../../cimsPage/instances/concrete'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: ConcreteNotifications,
  view: '865A9DE4-2BFE-494D-BE52-7121D1D55945',
  edit: 'CA72746A-D98F-4786-A802-9487EE7F2C24',
})

export const ViewConcreteNotification = View
export const EditConcreteNotification = Edit

export type ConcreteNotificationPermission =
  | typeof ViewConcreteNotification
  | typeof EditConcreteNotification
